class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#ajaxcart-overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#ajax-cart-icon, #ajax-cart-icon-redesign');
    cartLinks.forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(link);
      });

      link.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(link);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    // Timeout helps ensure animation triggers
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.cart-inner-empty')
          : document.getElementById('ajaxcart');
        const focusElement = this.querySelector('.drawer-inner');
        if (typeof triggerClick === 'function') {
          triggerClick(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    // Prevent "focus is not a function" error
    if (this.activeElement && typeof this.activeElement.focus === 'function' && typeof triggerClickClose === 'function') {
      triggerClickClose(this.activeElement);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });
    cartDrawerNote.parentElement.addEventListener('keyup', escClick);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer-inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    // ✅ Safely parse ajax-cart-icon HTML
    const parsedDoc = new DOMParser().parseFromString(
      parsedState.sections['ajax-cart-icon'],
      'text/html'
    );

    const bigCounterEl = parsedDoc.querySelector('.bigcounter');
    const totalPriceEl = parsedDoc.querySelector('.mini-cart-total-price');

    const resultCount = bigCounterEl ? bigCounterEl.innerHTML : '0';
    const resultTotalCount = totalPriceEl ? totalPriceEl.innerText : '';

    // ✅ Update cart icons safely
    const counterEls = document.querySelectorAll('#ajax-cart-icon-redesign, #ajax-cart-icon');
    counterEls.forEach((element) => {
      const counter = element.querySelector('.bigcounter');
      const totalPrice = element.querySelector('.mini-cart-total-price');
      if (counter) counter.innerHTML = resultCount;
      if (totalPrice) totalPrice.innerHTML = resultTotalCount;
    });

    // ✅ Update sections
    this.fetchSecToInclude().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = this.callSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // ✅ Re-bind overlay click and reopen drawer
    setTimeout(() => {
      const overlay = this.querySelector('#ajaxcart-overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    });
  }

  callSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  fetchSecToInclude() {
    return [
      {
        id: 'ajax-cart',
        selector: '#ajaxcart',
      },
      {
        id: 'ajax-cart-icon',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('ajax-cart', ajaxCart);

class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: 'ajaxcart',
        section: 'ajax-cart',
        selector: '.drawer-inner',
      },
      {
        id: 'ajax-cart-icon',
        section: 'ajax-cart-icon',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-pro', ajaxCartPro);
